import { render, staticRenderFns } from "./round-preview.component.vue?vue&type=template&id=2fbef4cc&scoped=true"
import script from "./round-preview.component.ts?vue&type=script&lang=ts&external"
export * from "./round-preview.component.ts?vue&type=script&lang=ts&external"
import style0 from "./round-preview.component.scss?vue&type=style&index=0&id=2fbef4cc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbef4cc",
  null
  
)

export default component.exports